import fetch from '@agilytics/fetch';

const production = process.env.NODE_ENV === 'production';
const REDIRECT_URI = production
  ? 'https://agilytics.leanloop.co.uk/jira/callback'
  : 'https://localhost:3000/jira/callback';
const CLIENT_ID = production ? 'H939hEqBC9LmMmTgSz0vAvuG2WE7j1yl' : 'qngNpkfXMEm0QjQHrQZ9l79qoieQhmw9';
const CLIENT_SECRET = production
  ? 'mNWqGpvTZxnZzuqVG_V5OLenUUqLAmLHvCP-11V7h6nyvvTM_nGYfUUccbo4jhv7'
  : 'fMiY3HxWYfrFLojNSFYTPxI9ljTYst6Gv4s9FcTGAVVDe0OY4NDRcBodml_nVcrA';
const DEFAULT_SCOPE = 'read:jira-user read:jira-work offline_access';

export const getConsentUrl = (state, scope = DEFAULT_SCOPE, clientId = CLIENT_ID, redirectUri = REDIRECT_URI) => {
  const params = new URLSearchParams();

  params.set('audience', 'api.atlassian.com');
  params.set('client_id', clientId);
  params.set('scope', scope);
  params.set('redirect_uri', redirectUri);
  params.set('state', state);
  params.set('response_type', 'code');
  params.set('prompt', 'consent');
  return `https://auth.atlassian.com/authorize?${params}`;
};

export const getAccessToken = async (state = '1234') => {
  const accessToken = window.localStorage.getItem('agilytics/accessToken');

  if (accessToken && !isTokenExpired()) {
    return accessToken;
  }
  const refreshedAccessToken = await refreshAccessToken();

  if (refreshedAccessToken) {
    return refreshedAccessToken;
  }
};

export const getTokensWithCode = async (
  code,
  clientId = CLIENT_ID,
  clientSecret = CLIENT_SECRET,
  redirectUri = REDIRECT_URI
) => {
  const data = {
    grant_type: 'authorization_code',
    client_id: clientId,
    client_secret: clientSecret,
    code: code,
    redirect_uri: redirectUri,
  };
  const response = await fetch('https://auth.atlassian.com/oauth/token', {
    method: 'POST',
    mode: 'cors',
    cache: 'no-cache',
    credentials: 'same-origin',
    headers: {
      'Content-Type': 'application/json',
    },
    redirect: 'follow',
    referrerPolicy: 'no-referrer',
    body: JSON.stringify(data),
  });
  const accessToken = response.access_token;

  window.localStorage.setItem('agilytics/refreshToken', response.refresh_token);
  window.localStorage.setItem('agilytics/expiresAt', Date.now() + (parseInt(response.expires_in) - 300) * 1000);
  window.localStorage.setItem('agilytics/accessToken', accessToken);

  return accessToken;
};

export const isTokenExpired = () => {
  const accessToken = window.localStorage.getItem('agilytics/accessToken');
  const expiresAt = window.localStorage.getItem('agilytics/expiresAt');
  return !accessToken || expiresAt <= Date.now();
};

export const refreshAccessToken = async (clientId = CLIENT_ID, clientSecret = CLIENT_SECRET) => {
  if (!isTokenExpired()) {
    return window.localStorage.getItem('agilytics/accessToken');
  }

  const refreshToken = window.localStorage.getItem('agilytics/refreshToken');
  if (!refreshToken) {
    return null;
  }
  const data = {
    grant_type: 'refresh_token',
    client_id: CLIENT_ID,
    client_secret: CLIENT_SECRET,
    refresh_token: refreshToken,
  };
  const response = await fetch('https://auth.atlassian.com/oauth/token', {
    method: 'POST',
    mode: 'cors',
    cache: 'no-cache',
    credentials: 'same-origin',
    headers: {
      'Content-Type': 'application/json',
    },
    redirect: 'follow',
    referrerPolicy: 'no-referrer',
    body: JSON.stringify(data),
  });
  const accessToken = response.access_token;

  window.localStorage.setItem('agilytics/expiresAt', Date.now() + (response.expires_in - 300) * 1000);
  window.localStorage.setItem('agilytics/accessToken', accessToken);

  return accessToken;
};

export default {
  getConsentUrl,
  refreshAccessToken,
  getTokensWithCode,
  isTokenExpired,
  getAccessToken,
};
